module.exports = __webpack_public_path__ + "img/info-icon.e7bd4180.svg";